import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    产品: [
      { label: '下载红桃视频App', to: '/' },
      { label: '红桃视频网页版', to: '/' },
      { label: '创作者平台', to: '/category/搞笑' },
      { label: '广告投放', to: '/about' },
    ],
    支持: [
      { label: '帮助中心', to: '/' },
      { label: '社区规范', to: '/article/5' },
      { label: '投诉建议', to: '/about' },
      { label: '意见反馈', to: '/about' },
    ],
    关于: [
      { label: '关于我们', to: '/about' },
      { label: '加入我们', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '隐私政策', to: '/' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">红桃视频</span>
            </Link>
            <p className="text-xs text-foreground-600 leading-relaxed mb-4">
              让每个人都能被发现
              <br />
              高清短视频，精彩每一刻
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 红桃视频 hongtaovideo.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">ICP备2024000000号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">网安备33010000000000号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}